import { initializeApp } from 'firebase/app'
import {
  browserLocalPersistence,
  browserSessionPersistence,
  connectAuthEmulator,
  getAuth,
  setPersistence,
} from 'firebase/auth'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { connectStorageEmulator, getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL:
    'https://db-digaah-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: 'G-08JFQQM7Q3',
}

const app = initializeApp(firebaseConfig)
const auth = getAuth()
const firestore = getFirestore(app)
const storage = getStorage(app)
const functions = getFunctions(app)
const useFirebaseEmulators =
  process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true'

// Los emuladores se habilitan explícitamente desde `npm run dev`.
// Abrir la app en localhost no debe redirigir por sí solo el tráfico de Firebase.
if (useFirebaseEmulators) {
  // Conectar Firestore al emulador en el puerto 8080
  connectFirestoreEmulator(firestore, 'localhost', 8080)
  // Conectar el emulador de autenticación en el puerto 9099 (puerto predeterminado)
  connectAuthEmulator(auth, 'http://localhost:9099')
  // Conectar Storage al emulador para evitar escrituras en el entorno live
  connectStorageEmulator(storage, 'localhost', 9199)
  connectFunctionsEmulator(functions, 'localhost', 5001)
}

export { auth, firestore, storage, functions }

// Configura la persistencia de autenticación
const persistance = useFirebaseEmulators
  ? browserLocalPersistence
  : browserSessionPersistence
setPersistence(auth, persistance)
